import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { inviteSchema } from '../types/invite';
import { queryKeys } from './queryKeys';

const responseSchema = z.object({
  invites: z.array(inviteSchema),
});

interface Params {
  projectId: string;
}

export function useGetProjectTeamInvites({ projectId }: Params) {
  const url = `/projects/${projectId}/team/invites`;

  const { data, error, isLoading } = useQuery({
    queryKey: queryKeys.getProjectTeamInvites(projectId),
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: !!projectId,
  });

  return {
    invites: data?.invites || [],
    error,
    isLoading,
  };
}
